<!--  -->
<template>
    <div class='content'>
        <div class="contents">
            <div class="screen">
                <div class="times">
                    <span> {{ language['选择时间'][LT] }}</span>
                    <el-date-picker @change="getChangeTime" v-model="value1" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                        type="datetimerange" :range-separator="language['至'][LT]" :start-placeholder="language['开始日期'][LT]"
                        :end-placeholder="language['结束日期'][LT]">
                    </el-date-picker>
                </div>
                <div class="table_num">
                    <span> {{ language['桌号'][LT] }}</span>
                    <el-select v-model="table_id" :placeholder="language['请选择'][LT]">
                        <el-option v-for="(item, index) in tableList" :key="index" :label="item.name"
                            :value="item.table_id">
                        </el-option>
                    </el-select>
                </div>
                <div class="btns">
                    <el-button type="danger" @click="getResetting"> {{ language['重置'][LT] }}</el-button>
                    <el-button type="primary" @click="getScreen"> {{ language['筛选'][LT] }}</el-button>
                </div>
            </div>
            <div class="table">
                <el-table :empty-text="language['暂无数据'][LT]" :data="orderList" border style="width: 100%"
                    :header-cell-style="{ background: '#eee', }">
                    <el-table-column align="center" type="index" label="ID" width="100">
                        <template slot-scope="scope">
                            <span>{{ scope.$index + 1 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="order_sn" :label="language['订单编号'][LT]"
                        width="180"></el-table-column>
                    <el-table-column align="center" prop="table_id" :label="language['桌台号'][LT]"></el-table-column>
                    <el-table-column align="center" prop="person_num" :label="language['就餐人数'][LT]"></el-table-column>
                    <el-table-column align="center" prop="payable_money" :label="language['金额'][LT]"></el-table-column>
                    <el-table-column align="center" prop="coupon_money" :label="'优惠金额'"></el-table-column>
                    <el-table-column align="center" prop="real_money" :label="language['实际支付金额(元)'][LT]"></el-table-column>
                    <el-table-column align="center" prop="pay_type" :label="language['支付方式'][LT]"></el-table-column>
                    <el-table-column align="center" prop="create_time" :label="language['开始时间'][LT]"></el-table-column>
                    <el-table-column align="center" prop="pay_time" :label="language['结算时间'][LT]"></el-table-column>
                    <el-table-column align="center" prop="user_name" :label="language['大王炭火烤肉料理'][LT]"></el-table-column>
                    <el-table-column align="center" :label="language['操作'][LT]">
                        <template slot-scope="scope">
                            <el-button @click="getRouter(scope.row)" type="text" size="small"> {{ language['详情'][LT]
                            }}</el-button>
                            <el-button @click="getPrint(scope.row)" type="text" size="small"> {{ language['打印'][LT]
                            }}</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="page">
                <el-pagination @current-change="getChange" :current-page="page" background layout="prev, pager, next"
                    :total="total"></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import language from '../../static/i18n/zh';

//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {
            value1: [],
            input: '',
            orderList: [],//订单列表
            total: 0,
            allPage: 0,
            page: 1,
            start_time: '',
            end_time: '',
            tableList: [],
            table_id: '',
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        // 订单管理
        getOrderList() {
            this.$post('64cf299d850c0', { table_id: this.table_id, start_time: this.start_time, end_time: this.end_time, page: this.page }).then(res => {
                if (res.code == 1) {
                    console.log('订单列表', res)
                    this.orderList = res.data.data;
                    this.total = res.data.total;
                    this.allPage = res.data.last_page;
                }
            })
        },
        // 切换分页
        getChange(event) {
            this.page = event;
            this.orderList = [];
            this.getOrderList();
        },
        // 时间筛选
        getChangeTime(e) {
            console.log(e)
            this.start_time = e[0];
            this.end_time = e[1];
            this.cacheData()
        },
        // 筛选
        getScreen() {
            this.orderList = [];
            this.page = 1;
            this.getOrderList();
        },
        // 缓存
        cacheData(){
          sessionStorage.setItem('start_time',this.start_time)
          sessionStorage.setItem('end_time',this.end_time)
        },
        // 重置
        getResetting() {
            this.value1 = [];
            this.start_time = '';
            this.end_time = '';
            this.table_id = '';
            this.getOrderList();
        },
        // 路由跳转
        getRouter(item) {
            this.$router.push({ path: '/orderDetail', query: { order_sn: item.order_sn } })
        },
        // 打印
        getPrint(item) {
            this.$post('64d2ef3687af8', { order_sn: item.order_sn }).then(res => {
                if (res.code == 1) {
                    console.log('打印小票', res)
                    this.$message({
                        message: this.language['打印成功'][this.LT],
                        type: 'success'
                    });
                }
            })
        },
        // 桌台列表
        getTableList() {
            this.$post('64c0f71d83b03').then(res => {
                if (res.code == 1) {
                    console.log('桌台列表', res)
                    this.tableList = res.data;
                    if (this.LT == 'zh') {
                        this.tableList.map(item => {
                            item.name = item.name + '号桌'
                        })
                    } else {
                        this.tableList.map(item => {
                            item.name = 'Table' + item.name
                        })
                    }
                }
            })
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
      this.start_time = sessionStorage.getItem('start_time')
      this.end_time = sessionStorage.getItem('end_time')
      this.value1.push(this.start_time,this.end_time)
        this.getOrderList();
        this.getTableList();
        console.log(this.LT);

    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.content {
    background: #eee;
    padding: 20px;
}

.contents {
    background: #fff;
    /* height: calc(100vh - 100px); */
    padding: 20px 10px;
    box-sizing: border-box;
}

.screen {
    display: flex;
    justify-content: flex-start;
    align-items: center;
}

.times span {
    font-size: 14px;
    display: inline-block;
    width: 80px;
}

.table_num {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-left: 40px;
}

.table_num span {
    display: inline-block;
    min-width: 50px;
    font-size: 14px;
    margin-right: 10px;
}

.btns {
    margin-left: 40px;
}

.table {
    margin-top: 30px;
}

.page {
    text-align: center;
    margin-top: 40px;
}
</style>



// WEBPACK FOOTER //
// src/view/orderList.vue